<app-multi-select-tree-view-drop-down
[dataSource]="demographicLookUp"
[enableRequiredValidation]="true"
requiredValidationMessage="{{'At least one demographics required'|translate}}"
[(dropDownSelection)]="selectedDemographics"
(dropDownSelectionChange)="onDemographicChanged($event)">
</app-multi-select-tree-view-drop-down>